import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import useScrollTrigger from '@mui/material/useScrollTrigger';

export default function ShrinkOnScrollAppBar({ children }) {
  // Cuando se scrollea más de 10px, trigger se pone true
  const trigger = useScrollTrigger({ threshold: 10 });

  return (
    <AppBar
      position="fixed"
      elevation={trigger ? 4 : 0}
      sx={{
        backgroundColor: 'primary.main',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        transition: 'height 0.3s',
        height: trigger ? 36 : 64,
        minHeight: trigger ? 36 : 64,
      }}
    >
      <Toolbar
      disableGutters
        sx={{
            minHeight: trigger ? '36px !important' : '64px !important',
            height: trigger ? '36px !important' : '64px !important',
            px: trigger ? 1 : 2,
            transition: 'all 0.3s',
            py: 0,
            alignItems: 'stretch',
        }}
      >
        {/* Pasa el prop shrink al hijo */}
        {React.cloneElement(children, { shrink: trigger })}
      </Toolbar>
    </AppBar>
  );
}
